<template>
  <v-card>
    <v-card-title>
      <span class="headline">Update Birth</span>
    </v-card-title>
    <v-date-picker class="calendar" v-model="birth" is-inline />
  
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {
      name: "editBirth",
      birth: null,
      errors: new Array()
    };
  },
  methods: {
    close() {
      this.$emit("close", this.name);
      this.birth = this.$store.getters.birth
    },
    save() {
      this.errors = [];

      if (this.errors.length == 0) {
        this.$store
          .dispatch("updateUserdata", {
            type: "main",
            name: "birth",
            value: this.birth
          })
          .then(() => {
            this.$emit("close", this.name);
            //this.username = this.$store.getters.username
          })
          .catch(() => {
            this.errors.push("Error");
          });
      }
    }
  }
};
</script>

<style scoped>
.headline {
  color: #4dbac0;
}
</style>